// extracted by mini-css-extract-plugin
export default {"recipe":"Recipe_recipe__QUcCg","recipeTitle":"Recipe_recipeTitle__b63I1","imageContainer":"Recipe_imageContainer__ylHHQ"};